<template>
  <div class="listing-card no-image">
    <div class="listing-detail">
      <div class="listing-data">
        <!-- company name -->
        <h3>
          <router-link :to="editRoute(company.id)">
            {{ company.name }}
          </router-link>
          <img
            v-if="company.landwehrId"
            src="@/assets/images/logo/zvoove_icon.svg"
            style="height: 20px"
            class="float-right"
          />
        </h3>
        <!-- address -->
        <div class="listing-data-block">
          <ul>
            <li>
              <span><i class="fas fa-phone-volume"></i></span>
              <template v-if="addressOutput() && addressOutput().telephone">
                <a :href="'callto:' + addressOutput().telephone">
                  {{ addressOutput().telephone }}
                </a>
              </template>
              <template v-else>Keine Angabe</template>
            </li>
            <template v-if="addressOutput()">
              <li>
                <span><i class="fal fa-map-marker-alt"></i></span>
                {{
                  addressOutput().street
                    ? addressOutput().street
                    : "Keine Angabe"
                }}
              </li>
              <li>
                <template v-if="addressOutput().zip">
                  {{ addressOutput().zip }}
                </template>
                <template v-if="addressOutput().city">
                  {{ addressOutput().city }}
                </template>
              </li>
            </template>
            <template v-else>
              <li>
                <span><i class="fal fa-map-marker-alt"></i></span>
                Keine Angabe
              </li>
            </template>
          </ul>
        </div>
        <!-- contact -->
        <div class="listing-data-block">
          <ul v-if="company.contactPartners.length">
            <li>
              <i class="fas fa-user"></i>
              {{ salutations[company.contactPartners[0].salutation] }}
              {{ company.contactPartners[0].lastName }}
            </li>
            <li v-if="company.contactPartners[0].telephone">
              <a :href="'callto:' + company.contactPartners[0].telephone">
                {{ company.contactPartners[0].telephone }}
              </a>
            </li>
            <li v-if="company.contactPartners[0].telephoneMobile">
              <a :href="'callto:' + company.contactPartners[0].telephoneMobile">
                {{ company.contactPartners[0].telephoneMobile }}
              </a>
            </li>
            <li v-if="company.contactPartners[0].email">
              <a :href="'mailto:' + company.contactPartners[0].email">
                {{ company.contactPartners[0].email }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- action buttons -->
    <div class="listing-actions two-cols">
      <span
        class="short-profile-action"
        title="Firma anzeigen"
        @click="$router.push(editRoute(company.id))"
      >
        <router-link :to="editRoute(company.id)">
          <i class="fal fa-building"></i>
        </router-link>
      </span>
      <div class="listing-delete cursor-pointer" @click="deleteRecord()">
        <feather-icon icon="trash" svg-classes="h-5 w-5 hover:text-danger" />
      </div>
    </div>
  </div>
</template>

<script>
import salutations from "@/data/enums/Salutation.js";

export default {
  props: {
    company: { type: Object, required: true }
  },
  data() {
    return {
      salutations
    };
  },
  methods: {
    addressOutput() {
      if (this.company.billingAddress) {
        return this.company.billingAddress;
      } else if (this.company.postAddress) {
        return this.company.postAddress;
      } else {
        return null;
      }
    },
    editRoute(id) {
      return `/company/${id}/edit`;
    },
    deleteRecord() {
      this.$emit("delete");
    }
  }
};
</script>
